'kiwi public';

/** @module */
import _typeof from "@babel/runtime-corejs3/helpers/esm/typeof";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/esm/toConsumableArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import Logger from '@/libs/Logger';
import * as Misc from '@/helpers/Misc';
var log = Logger.namespace('chathistory');

/**
 * Adds the CHATHISTORY IRCv3 spec to irc-framework
 */
export default function chathistoryMiddleware() {
  return function middleware(client, rawEvents, parsedEvents) {
    client.requestCap('draft/chathistory');
    addFunctionsToClient(client);
    parsedEvents.use(theMiddleware);
  };
  function theMiddleware(command, event, client, next) {
    var _event$command;
    if (command.toLowerCase() === 'batch end chathistory' && client.chathistory) {
      var target = event.params[0];
      client.chathistory.batchCallbacks.resolve(target, event);
    }

    // This is sent as 'unknown command', its been structured this way so hopefully it
    // will still work if a fail handler is ever created in irc-fw
    if ((event === null || event === void 0 || (_event$command = event.command) === null || _event$command === void 0 ? void 0 : _event$command.toLowerCase()) === 'fail' && event.params[0].toLowerCase() === 'chathistory') {
      client.chathistory.batchCallbacks.resolve(event.params[3]);
      if (event.params[1].toLowerCase() === 'invalid_target') {
        // suppress invalid target errors
        return;
      }
    }
    next();
  }
}
function addFunctionsToClient(client) {
  var history = client.chathistory = {};
  history.batchCallbacks = {
    callbacks: Object.create(null),
    queue: [],
    queueActive: false,
    add: function add(cb, target, type) {
      this.callbacks[target.toUpperCase()] = this.callbacks[target.toUpperCase()] || [];
      this.callbacks[target.toUpperCase()].push(cb);
      for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        args[_key - 3] = arguments[_key];
      }
      this.queue.push({
        target: target,
        type: type,
        args: args
      });
      if (!this.queueActive) {
        this.queueNext();
      }
    },
    resolve: function resolve(target, value) {
      var targetCallbacks = this.callbacks[target.toUpperCase()] || [];
      var cb = targetCallbacks.shift();
      if (!targetCallbacks.length) {
        // last callback, cleanup callbacks
        delete this.callbacks[target.toUpperCase()];
      }
      if (cb) {
        cb(value);
      } else if (history.isSupported()) {
        // inspircd currently does not support chathistory
        // but sends chathistory batches when joining channels
        log.error('chathistory got a resolve but no associated callback');
      }
      this.queueNext();
    },
    queueNext: function queueNext() {
      var _context;
      this.queueActive = true;
      var nextRequest = this.queue.shift();
      if (!nextRequest) {
        this.queueActive = false;
        return;
      }
      client.raw.apply(client, _concatInstanceProperty(_context = ['CHATHISTORY', nextRequest.type, nextRequest.target]).call(_context, _toConsumableArray(nextRequest.args)));
    }
  };

  // supports (ISUPPORT) is used by kiwibnc, the spec and unreal's implementation uses CAP
  history.isSupported = function () {
    return !!client.network.supports('draft/chathistory') || client.network.cap.isEnabled('draft/chathistory');
  };
  history.before = function (target, dateOrTime) {
    return new _Promise(function (resolve) {
      if (!history.isSupported()) {
        resolve();
        return;
      }
      history.batchCallbacks.add(resolve, target, 'BEFORE', messageReference(dateOrTime), '50');
    });
  };
  history.after = function (target, dateOrTime) {
    return new _Promise(function (resolve) {
      if (!history.isSupported()) {
        resolve();
        return;
      }
      history.batchCallbacks.add(resolve, target, 'AFTER', messageReference(dateOrTime), '50');
    });
  };
  history.latest = function (target, dateOrTime) {
    return new _Promise(function (resolve) {
      if (!history.isSupported()) {
        resolve();
        return;
      }
      history.batchCallbacks.add(resolve, target, 'LATEST', messageReference(dateOrTime), '50');
    });
  };
  history.around = function (target, dateOrTime) {
    return new _Promise(function (resolve) {
      if (!history.isSupported()) {
        resolve();
        return;
      }
      history.batchCallbacks.add(resolve, target, 'AROUND', messageReference(dateOrTime), '50');
    });
  };
  history.between = function (target, fromDateOrTime, toDateOrTime) {
    return new _Promise(function (resolve) {
      if (!history.isSupported()) {
        resolve();
        return;
      }
      var fromRef = messageReference(fromDateOrTime);
      var toRef = messageReference(toDateOrTime);
      history.batchCallbacks.add(resolve, target, 'BETWEEN', fromRef, toRef, 50);
    });
  };
  function messageReference(inp) {
    if (_typeof(inp) === 'object') {
      return 'timestamp=' + Misc.dateIso(inp);
    }
    if (inp === '*') {
      return '*';
    }
    return 'msgid=' + inp;
  }
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["ChathistoryMiddleware"]
window._kiwi_exports.libs.ChathistoryMiddleware = (typeof exports !== 'undefined' ? (exports.default || exports) : (typeof module !== 'undefined' && module.exports ? (module.exports.default || module.exports) : {}));
